import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to know when and how to take risks.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>isn't it interesting?
                                            </div>
                                            <p>How much would you bet on the toss of a coin? £5? £10? £50?
                                                £1000?</p>
                                            <div className="border_subtitle">Risk versus reward</div>
                                            <p>The answer to this question depends on a logical interpretation
                                                of the odds and the associated
                                                risks and rewards. However, as much as we like to think of
                                                ourselves as logical beings, under
                                                certain circumstances this is far from the case. The study below
                                                clearly shows the logical errors
                                                we can make when making decisions.</p>
                                            <div className="lightgreencontentbg keyquestionpad ">
                                                <div className="border_subtitle">Risky decision making</div>
                                                <div><p>In 1979, two psychologists published influential
                                                    research that would ultimately lead them
                                                    to receive the Nobel Prize. Daniel Kahneman and Amos Tversky<a
                                                        className="superscripttext"
                                                        href="further_info.php?course=300"><sup>1</sup></a> investigated
                                                    the apparent
                                                    strange and illogical behaviour demonstrated when people
                                                    take risks.</p></div>
                                                <p>Participants were asked whether they would be willing to bet
                                                    £10 on the toss of a coin if
                                                    they stood a chance of winning £20. So a 50% chance of
                                                    winning £20 and a 50% chance
                                                    of losing £10. It’s clear that you have more to potentially
                                                    gain than to potentially lose, so
                                                    it’s interesting that people tended to avoid this bet. It
                                                    seems that when there are potential
                                                    gains, we tend to become more risk averse.</p>
                                                <p>Conversely, consider this example. You have two options
                                                    available to you. The first is that
                                                    you have an 85% chance of losing £1000 and a 15% chance of
                                                    losing nothing. The second
                                                    option is that you have a 100% chance of losing £800 – not
                                                    much of a choice I hear you
                                                    cry. Still, sometimes it is best to cut your losses and the
                                                    maths states that the second
                                                    option is the most sensible. However, most people will
                                                    prefer the 85% chance of losing
                                                    £1000 over the absolute certainty of losing £800. It seems
                                                    that when there are potential
                                                    losses, we tend to become more risk seeking.</p>
                                                <div className="uiheading"><p>It seems then that when faced with
                                                    taking risks, our decision making processes can turn
                                                    themselves on their head.</p></div>
                                            </div>

                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}